import { Logo } from '@/components/Logo';
import i18n from '@/translations/config';
import { FaBars } from 'react-icons/fa';
import { Link } from 'react-router-dom';

export const SidebarHeader = ({
  toggleSidebar,
}: {
  toggleSidebar: () => void;
}) => (
  <div className="sticky top-0 z-10 flex items-center justify-between border-b border-sky-100 bg-white px-4 py-3 text-sky-800 lg:hidden">
    <Link
      to={`/${i18n.language}/dashboard`}
      className="flex items-center gap-2"
    >
      <Logo />
    </Link>
    <button
      onClick={toggleSidebar}
      className="rounded-lg p-2 text-sky-700 hover:bg-sky-50"
    >
      <FaBars className="size-6" />
    </button>
  </div>
);
